import { Users, CalendarDays, ClipboardCheck, Eye } from "lucide-react";

export function FamilyLifeSection() {
  return (
    <section className="space-y-6 text-center">
      <h2 className="text-2xl font-display font-bold">Fungerer for hele familien</h2>
      <p className="text-muted-foreground max-w-md mx-auto">
        Flyt fungerer enten dere bor sammen eller deler hverdagen mellom to hjem.
      </p>
      <p className="text-sm text-muted-foreground max-w-md mx-auto">
        Enda bedre når dere deler oversikt og ansvar.
      </p>
      <div className="max-w-md mx-auto text-left space-y-3">
        {[
          { icon: Users, text: "Passer samboere, gifte og aleneforeldre" },
          { icon: CalendarDays, text: "Felles samværskalender (Sammen)" },
          { icon: ClipboardCheck, text: "Sømløse overleveringer med sjekklister" },
          { icon: Eye, text: "Begge foreldre ser samme fremgang" },
        ].map((item) => (
          <div key={item.text} className="flex items-start gap-3">
            <item.icon className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <p className="text-sm">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
